import {
    UddannelsesstedForloebKladderResponseModel
} from "../../../services/api/forloeb/uddannelsesstedForloebKladderResponseModel";
import {StillingForloebKladderOverviewModel} from "../stilling/stillingForloebKladderOverviewModel";
import {AfdelingStillingForloebKladderModel} from "../stilling/afdelingStillingForloebKladderModel";
import { OverlapCompareModel } from "../OverlapCompareModel";

export class UddannelsesstedForloebKladderModel {
    public static FromResponseModel(responseModel: UddannelsesstedForloebKladderResponseModel): UddannelsesstedForloebKladderModel {
        const model = new UddannelsesstedForloebKladderModel();
        model.uddannelsesstedId = responseModel.uddannelsesstedId;
        model.uddannelsesstedNavn = responseModel.uddannelsesstedNavn;
        model.praksisStillingerForloebKladder = responseModel.praksisForloebKladder.map(s => StillingForloebKladderOverviewModel.FromResponseModel(s));
        model.afdelingStillinger = responseModel.afdelingerMedForloebKladder.map(s => AfdelingStillingForloebKladderModel.FromResponseModel(s));
        return model;
    }

    public GetAllForloebCompareModels(): OverlapCompareModel[] {
        const allforloebCompareModels: OverlapCompareModel[] = [
                ...this.praksisStillingerForloebKladder.flatMap(y => y.forloebKladde),
                ...this.afdelingStillinger.flatMap(y => y.afdelingStillingForloebKladder.flatMap(s => s.forloebKladde))
            ]
        return allforloebCompareModels;
    }

    public uddannelsesstedId: string;
    public uddannelsesstedNavn: string;
    public praksisStillingerForloebKladder: StillingForloebKladderOverviewModel[];
    public afdelingStillinger: AfdelingStillingForloebKladderModel[];
}
